module.exports = "/virtual-football-league/img/amblems/right/logos/Fake_Broomwich.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Fake_Broomwich.png
// module id = 2182
// module chunks = 4